import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Entry, JurorSelection } from '../entry';

@Component({
  selector: 'app-judge-entry',
  templateUrl: './judge-entry.component.html',
  styleUrls: ['./judge-entry.component.less']
})
export class JudgeEntryComponent implements OnInit {
  @Input() entry: Entry;
  @Output() selectEntry: EventEmitter<JurorSelection> = new EventEmitter<JurorSelection>();
  loading = true;

  constructor() { }

  ngOnInit(): void {
  }

  onLoad() {
      this.loading = false;
  }

  bubbleEntry(selection: JurorSelection) {
    this.selectEntry.emit(selection);
  }
}
